import bootbox from 'bootbox';
import _ from 'lodash';

import environment from '../../../environment';
import { ControlType, Item } from '../../../workspaces/item';
import Workspace from '../../../workspaces';

export class ZoomLevel {
    constructor (layer, options) {
        this.layer = layer;
        this.options = _.assign({}, {
            id: 0,
            property: 'locationType',
            map: undefined,
            areas: undefined,
            type: 'SelectedAreas'
        }, options);
    }

    setOptions (options) {
        this.options = _.assign({}, this.options, options);
        if (options.id) {
            // Removed control of zoom requested by: Alexandre Ayres.
            //this._changeZoomLevel(this.options.id);
            //return this._updateLayerParams(this.options.id);
        }
    }

    setId (id) { return this.setOptions({ id }); }

    setLayer (layer) { if (layer) { this.layer = layer; } }

    get () {
        if (this.options.type === 'SelectedAreas') {
            switch (Number(this.options.id)) {
            case environment.get('TYPE.DYNAMIC'):
                const location = this._getZoomLocation(this.options.type);
                this._updateLayerParams(location.id);
                return [location.zoom.min - 1, location.zoom.max + 1];
            case environment.get('TYPE.SETORCENSITARIO'):
                return [13, 18];
            case environment.get('TYPE.BAIRRO'):
                return [9, 18];
            case environment.get('TYPE.DISTRITO'):
            case environment.get('TYPE.SUBDISTRITO'):
            case environment.get('TYPE.MUNICIPIO'):
                return [7, 18];
            default:
                return [4, 18];
            }
        } 

        if (this.options.type === 'SelectedAreasAfterSales') {    
            switch (Number(this.options.id)) {
            case environment.get('TYPE.DYNAMIC'):
                const location = this._getZoomLocation(this.options.type);
                this._updateLayerParams(location.id);
                return [location.zoom.min - 1, location.zoom.max + 1];
            case environment.get('TYPE.SETORCENSITARIO'):
                return [13, 18];
            case environment.get('TYPE.SETORCENSITARIONEOCORP'):
                return [13, 18];
            case environment.get('TYPE.BAIRRO'):
                return [9, 18];
            case environment.get('TYPE.DISTRITO'):
            case environment.get('TYPE.SUBDISTRITO'):
            case environment.get('TYPE.MUNICIPIO'):
                return [7, 18];
            default:
                return [4, 18];
            }
        } 

        switch (Number(this.options.id)) {
            default:
                return [4, 18];
        }
    }

    _getZoomLocation (type = 'SelectedAreas') {
        const areas = {
            selectedareas: environment.get('CONFIG.FILTERS.AREAS_TYPES'),
            markedarea: environment.get('CONFIG.FILTERS.MARKED_AREA_TYPES')
        };

        try {
            return _(this.options.areas || areas[type.toLowerCase()])
                .filter(z => z.zoom)
                .find(z => _.inRange(this.options.map.getZoom(), z.zoom.min - 1, z.zoom.max + 1)) ||
                { zoom: {} };
        } catch (err) {
            console.log(err);
            return { zoom: {} };
        }
    }

    _changeZoomLevel () {
        if (this.options.type === 'SelectedAreas') {
            switch (Number(this.options.id)) {
            case 1:
            case environment.get('TYPE.DYNAMIC'):
                return;
            case environment.get('TYPE.SETORCENSITARIO'):
                return this._setZoomLevel(14);
            case environment.get('TYPE.BAIRRO'):
                return this._setZoomLevel(13);
            case environment.get('TYPE.DISTRITO'):
            case environment.get('TYPE.SUBDISTRITO'):
                return this._setZoomLevel(12);
            case environment.get('TYPE.MUNICIPIO'):
            case environment.get('TYPE.MICRORREGIAO'):
                return this._setZoomLevel(10);
            case (environment.get('TYPE.PAIS') || 0):
            case environment.get('TYPE.REGIAO'):
            case environment.get('TYPE.UF'):
                return this._setZoomLevel(5);
            default:
                return this._setZoomLevel(9);
            }
        } else {
            switch (Number(this.options.id)) {
            case (environment.get('TYPE.AREACONTRATUAL') || 15):
                return this._setZoomLevel(11);
            case (environment.get('TYPE.DVA') || 3):
                return this._setZoomLevel(10);
            case (environment.get('TYPE.AREADEMARCADA') || 1):
            case (environment.get('TYPE.MVA') || 16):
                return this._setZoomLevel(9);
            case (environment.get('TYPE.REGIONALATUAL') || 11):
                return this._setZoomLevel(7);
            case (environment.get('TYPE.REGIONALRECOMENDADA') || 12):
            case (environment.get('TYPE.AOV') || 13):
                return this._setZoomLevel(5);
            default:
                return this._setZoomLevel(8);
            }
        }
    }

    _updateLayerParams (id) {
        const curId = this.layer.options.remote.params[this.options.property];
        if (id && curId !== id) {
            this.layer.clearFeatures();
            const options = { remote: this.layer.options.remote };
            options.remote.params[this.options.property] = id;
            return this.layer.setOptions(options);
        }
    }

    _setZoomLevel (zoomLevel) {
        if (!this.options.map || _.inRange(+this.options.map.getZoom(), (+zoomLevel - 3), (+zoomLevel + 3))) { return; }

        const onZoomLevel = (e) => {
            this.options.map.setZoom(zoomLevel);
            if (this.options.map.hasLayer(this.layer)) {
                setTimeout(() => {
                    this.layer.redraw();
                }, 1000);
            }

            Workspace.addAction(new Item('.bootbox button.btn-success', '', ControlType.InputButton));
        };

        return bootbox.dialog({
            title: '<i class="fa fa-warning"></i> Aviso',
            message: 'Ir para nível de zoom adequado da camada selecionada',
            backdrop: false,
            buttons: {
                main: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-default',
                    callback: () => {
                        Workspace.addAction(new Item('.bootbox button.btn-default', '', ControlType.InputButton));
                    }
                },
                danger: {
                    label: '<i class="fa fa-check"></i> Ir',
                    className: 'btn-success',
                    callback: onZoomLevel
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/scripts/layers/Leaflet/VectorLayer/ZoomLevel.js